import { render, staticRenderFns } from "./new_receipt.vue?vue&type=template&id=6193cbe2&scoped=true"
import script from "./new_receipt.vue?vue&type=script&lang=js"
export * from "./new_receipt.vue?vue&type=script&lang=js"
import style0 from "./new_receipt.vue?vue&type=style&index=0&id=6193cbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6193cbe2",
  null
  
)

export default component.exports